module.exports = __webpack_public_path__ + "static/img/sou-w@2x.db4efe10.png";